/** Sentry's own DSN pattern: http(s)://<public key>@<host>[:port]/[path/]<numeric project ID>. */
const SENTRY_DSN = /^https?:\/\/\w+(?::\w*)?@(?:\[[:.%\w]+\]|[\w.-]+)(?::\d+)?\/(?:.+\/)?\d+$/;

/** Shown when a DSN is rejected; never includes the value itself. */
export const SENTRY_DSN_FORMAT = 'must be a Sentry DSN such as https://<key>@<host>/<project-id>';

/**
 * Sentry ignores a DSN it can't parse and then quietly reports nothing, so
 * configuration checks the format up front and fails at startup instead.
 */
export function isSentryDsn(value: string): boolean {
  return SENTRY_DSN.test(value);
}
